import { ConfirmIdentityProps } from './ConfirmIdentity.props';

import ConfirmIdentityView from './ConfirmIdentity.view';

const ConfirmIdentityContainer = (props: ConfirmIdentityProps) => {
  return <ConfirmIdentityView />;
};

export default ConfirmIdentityContainer;
